import { useEffect, useState } from "react";
import { IoMdCheckmark } from "react-icons/io";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { NavLink, Outlet } from "react-router-dom";
import {
  changePassword,
  createNotification,
  fetchNotification,
  getSettings,
  updateSettings,
} from "../../api/setting";
import { toast } from "react-toastify";
import { JTCookies } from "../../utils/storage/cookies";
import { usePermissionEffect } from "../../utils/usePermissionEffect";

const linkStyle = {
  display: "inline-block",
  padding: "4px",
  margin: "0px 30px 0px 0px",
  color: "#828282",
  fontSize: "15px",
  position: "relative",
};
const selectedLink = "!text-dark font-bold after:!w-full after:bg-dark ";

const settings = () => {
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const ls = localStorage.getItem("permissions");
    try {
      const parsedLs = JSON.parse(ls);
      setPermissions(parsedLs);
    } catch (error) {}
  }, []);

  const getModulePermission = (module, section) => {
    const pers = permissions?.find(
      (per) =>
        String(per?.module?.toLowerCase()) === String(module.toLowerCase()),
    )?.permissions;
    return pers ? pers[section] : false;
  };
  
  return (
    <div className="w-full font-Neurial h-full pt-5 px-5 pb-40 space-y-6">
      <div className="flex flex-col gap-5">
        <div className="font-bold text-[22px] text-[#070E05]">Settings</div>
        <div className="settings-box block whitespace-nowrap overflow-x-auto relative border-b-[1px] border-b-[#BDBDBD] py-2">
          <NavLink
            end
            to=""
            className={({ isActive }) => (isActive ? selectedLink : "")}
            style={linkStyle}
          >
            <div className="">Account</div>
          </NavLink>
          <NavLink
            to="/settings/security"
            className={({ isActive }) => (isActive ? selectedLink : "")}
            style={linkStyle}
          >
            <div className="">Security</div>
          </NavLink>
          {/* <NavLink
              to="/settings/notifications"
              className={({ isActive }) => (isActive ? selectedLink : "")}
              style={linkStyle}
            >
              <div className="">Notifications</div>
            </NavLink> */}
          {getModulePermission("banner", "canView") && (
          <NavLink
            to="/settings/banners"
            className={({ isActive }) => (isActive ? selectedLink : "")}
            style={linkStyle}
          >
            <div className="">Banners</div>
          </NavLink>
          )}
          {getModulePermission("role", "canView") && (
            <NavLink
              to="/settings/roles"
              className={({ isActive }) => (isActive ? selectedLink : "")}
              style={linkStyle}
            >
              <div className="">Roles and Permissions</div>
            </NavLink>
          )}
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default settings;

export const Account = () => {
  const queryClient = useQueryClient();
  const { data } = useQuery("settings", getSettings);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    if (data) {
      setFirstName(data?.firstName);
      setLastName(data?.lastName);
      setEmail(data?.email);
      setPhoneNumber(data?.phoneNumber);
      setRole(data?.role);
    }
  }, [data]);

  const mutation = useMutation(updateSettings, {
    onSuccess: () => {
      queryClient.invalidateQueries("settings");
      toast.success("Profile updated");
    },
    onError: (e) => {
      toast.error(e.message);
    },
  });

  const onFinish = (e) => {
    e.preventDefault();
    const data = {
      firstName,
      lastName,
      email,
      phoneNumber,
    };

    mutation.mutate(data);
  };

  const logOut = () => {
    const cookies = new JTCookies(document);
    cookies.removeAllCookies();
    window.location.href = "/";
  };

  return (
    <div className="flex flex-col gap-10">
      <div className="bg-white rounded-lg p-5">
        <div className="flex flex-col gap-4">
          <div className="w-11/12">
            <form onSubmit={onFinish} className="space-y-5">
              <div className="flex items-center gap-3 border-b-[#7C7C7C1A] border-b-[1px] py-4">
                <div className="h-[100px] w-[100px] bg-dark rounded-full"></div>
                <div className="space-y-3">
                  <button
                    type="button"
                    className="cusor-pointer border-none bg-[#0000001A] text-dark font-bold px-2 py-1 w-fit rounded-[5px] text-[12px]"
                  >
                    Upload Photo
                  </button>
                  <div className="text-[#828282] text-[12px]">
                    Allowed JPG and PNG. Max size of 1MB
                  </div>
                </div>
              </div>
              <div
                className="grid gap-4"
                style={{
                  gridTemplateColumns: "repeat(auto-fit, minmax(48%, 0fr))",
                }}
              >
                <div className="flex flex-col gap-3">
                  <div className="text-[#181819E5] text-[15px]">First Name</div>
                  <div className="">
                    <input
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[50px] px-4"
                    />
                  </div>

                  <div className="text-[#181819E5] text-[15px]">Last Name</div>
                  <div className="">
                    <input
                      onChange={(e) => setLastName(e.target.value)}
                      value={lastName}
                      className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[50px] px-4"
                    />
                  </div>

                  <div className="text-[#181819E5] text-[15px]">
                    Email Address
                  </div>
                  <div className="">
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[50px] px-4"
                    />
                  </div>

                  <div className="text-[#181819E5] text-[15px]">
                    Phone Number
                  </div>
                  <div className="">
                    <input
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      value={phoneNumber}
                      className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[50px] px-4"
                    />
                  </div>
                </div>
                <div className="space-y-1">
                  <div className="text-[#181819E5] text-[15px]">Role</div>
                  <div className="">
                    <input
                      value={role}
                      disabled
                      className="w-full text-[14px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[50px] px-4"
                    />
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3 font-bold text-[15px] ">
                <button
                  className={`bg-dark text-white rounded-[5px] px-3 py-2 ${mutation.isLoading ? "animate-pulse" : ""}`}
                  type="submit"
                >
                  {mutation.isLoading ? "Saving..." : "Save Details"}
                </button>
                <button
                  className="text-dark bg-[#0000000D] px-3 py-2 rounded-[5px]"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="bg-transparent rounded-lg p-5">
        <div className="flex flex-col gap-4">
          <div className="mt-6">
            <button
              className="bg-[#EB5757] font-bold text-[15px] text-white rounded-[5px] px-3 py-2"
              type="button"
              onClick={logOut}
            >
              Log Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Security = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const onReset = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
  };

  const mutation = useMutation(changePassword, {
    onSuccess: () => {
      toast.success("Password successfully changed");
      onReset();
    },
    onError: (e) => {
      toast.error(e.message);
    },
  });

  const onFinish = (e) => {
    e.preventDefault();
    const data = {
      currentPassword,
      newPassword,
      confirmNewPassword,
    };

    mutation.mutate(data);
  };

  return (
    <div className="flex flex-col gap-10">
      <div className="bg-white rounded-lg p-5">
        <div className="flex flex-col gap-4">
          <div className="font-bold text-[18px]">Change Password</div>
        </div>
        <form onSubmit={onFinish} className="flex flex-col gap-4 my-4">
          <div className="space-y-1 w-[49%]">
            <div className="text-[#181819E5] text-[14px]">Current Password</div>
            <div className="">
              <input
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="w-full text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[50px] px-4"
                placeholder="e.g John"
              />
            </div>
          </div>
          <div className="flex items-center w-full gap-4">
            <div className="space-y-1 w-full">
              <div className="text-[#181819E5] text-[14px]">New Password</div>
              <div className="">
                <input
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="w-full text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[50px] px-4"
                  placeholder="e.g John"
                />
              </div>
            </div>
            <div className="space-y-1 w-full">
              <div className="text-[#181819E5] text-[14px]">
                Confirm New Password
              </div>
              <div className="">
                <input
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  className="w-full text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[50px] px-4"
                  placeholder="e.g John"
                />
              </div>
            </div>
          </div>
          <div className="space-y-3">
            <div className="font-bold text-[15px]">Password Requirements</div>
            <div className="space-y-2 text-[#4F4F4F] font-medium text-[13px]">
              <div className="flex items-center gap-2">
                <IoMdCheckmark /> At least 8 characters
              </div>
              <div className="flex items-center gap-2">
                <IoMdCheckmark /> Upper and lower case characters
              </div>
              <div className="flex items-center gap-2">
                <IoMdCheckmark /> 1 or more numbers
              </div>
              <div className="flex items-center gap-2">
                <IoMdCheckmark /> 1 or more special characters
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3 font-bold text-[15px] ">
            <button
              className="bg-dark text-white rounded-[5px] px-3 py-2"
              type="submit"
            >
              Save Changes
            </button>
            <button
              className="text-dark bg-[#0000000D] px-3 py-2 rounded-[5px]"
              type="button"
              onClick={onReset}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const Notifications = () => {
  const queryClient = useQueryClient();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [device, setDevice] = useState([]);
  const { getModulePermission } = usePermissionEffect();

  const { data } = useQuery("notifications", fetchNotification, {
    onError: (e) => toast.error(e.message),
  });

  const onReset = () => {
    setTitle("");
    setMessage("");
    setDevice([]);
  };

  const mutation = useMutation(createNotification, {
    onSuccess: () => {
      queryClient.invalidateQueries("notifications");
      onReset();
      toast.success("Notification sent");
    },
    onError: (e) => {
      toast.error(e.message);
    },
  });

  const onFinish = (e) => {
    e.preventDefault();
    const values = {
      title,
      message,
      device,
    };

    mutation.mutate(values);
  };

  return (
    <div className="flex flex-col gap-10">
      <div className="bg-white rounded-lg py-5 px-7">
        <div className="flex gap-12">
          <div className="flex flex-col gap-4  w-1/2">
            <div className="font-bold text-[16px]">Push Notifications</div>
            <form onSubmit={onFinish} className="flex flex-col gap-4 my-4">
              <div className="space-y-1">
                <div className="">
                  <input
                    className="w-full text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[50px] px-4"
                    placeholder="Create Notification Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    maxLength={24}
                  />
                </div>
                <div className="text-[#7B7B7B] text-right text-[12px]">
                  {title.length}/24
                </div>
              </div>
              <div className="space-y-1">
                <div className="">
                  <textarea
                    className="w-full text-[13px] placeholder:text-[#A0A3BD] border-[#E6E7E9] border-[1px] bg-transparent rounded-lg h-[100px] resize-none px-4 py-2"
                    placeholder="Create Push Notification "
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    maxLength={115}
                  />
                </div>
                <div className="text-[#7B7B7B] text-right text-[12px]">
                  {message.length}/115
                </div>
              </div>
              <div className="space-y-1">
                <div className="text-[#181819E5] text-[14px]">
                  Select devices
                </div>
                <div className="py-3 space-y-3">
                  <div
                    className="flex gap-1 bg-white rounded-lg p-4"
                    style={{ boxShadow: "0px 4px 50px 5px #0000000D" }}
                  >
                    <label className="check-container">
                      <input
                        id="android"
                        type="checkbox"
                        defaultChecked={device.includes("andriod")}
                        onChange={(e) =>
                          setDevice((prev) =>
                            prev.includes("android")
                              ? prev.filter((p) => p !== "android")
                              : [...prev, "android"],
                          )
                        }
                      />
                      <span className="checkmark"></span>
                    </label>
                    <label
                      className="font-medium font-inter text-[15px] text-[#2D2E2C]"
                      htmlFor="android"
                    >
                      Android
                    </label>
                  </div>
                  <div
                    className="flex gap-1 bg-white rounded-lg p-4"
                    style={{ boxShadow: "0px 4px 50px 5px #0000000D" }}
                  >
                    <label className="check-container">
                      <input
                        id="ios"
                        type="checkbox"
                        defaultChecked={device.includes("ios")}
                        onChange={(e) =>
                          setDevice((prev) =>
                            prev.includes("ios")
                              ? prev.filter((p) => p !== "ios")
                              : [...prev, "ios"],
                          )
                        }
                      />
                      <span className="checkmark"></span>
                    </label>
                    <label
                      className="font-medium font-inter text-[15px] text-[#2D2E2C]"
                      htmlFor="ios"
                    >
                      iOS
                    </label>
                  </div>
                  {/* <div
                      className="flex gap-1 bg-white rounded-lg p-4"
                      style={{ boxShadow: "0px 4px 50px 5px #0000000D" }}
                    >
                      <label className="check-container">
                        <input
                          id="web"
                          type="checkbox"
                          defaultChecked={device.includes('web')}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <label
                        className="font-medium font-inter text-[15px] text-[#2D2E2C]"
                        htmlFor="web"
                      >
                        Web
                      </label>
                    </div> */}
                </div>
              </div>
                {getModulePermission("notification", "canCreate") && (              
              <div className="flex items-center gap-3 font-bold text-[15px] ">
                <button
                  className={`bg-dark text-white rounded-[5px] px-3 w-full py-2 ${mutation.isLoading ? "animate-pulse" : ""}`}
                  type="submit"
                >
                  {mutation.isLoading ? "Saving..." : "Send notifications"}
                </button>
                <button
                  className="text-dark bg-[#0000000D] px-3 py-2 w-full rounded-[5px]"
                  type="button"
                  onClick={onReset}
                >
                  Cancel
                </button>
              </div>
                )}
            </form>
          </div>
          <div className="w-1/2 flex flex-col gap-4 px-1 h-[560px] pb-16 overflow-y-auto">
            <div className="flex items-center justify-between font-bold text-[16px] sticky top-0 bg-white pb-3">
              <span>Notification history</span>
              <span>{data?.total || 0}</span>
            </div>
            <div className="space-y-4 px-2">
              {(data?.notifications || []).map((v, k) => {
                return (
                  <div
                    key={k}
                    className="bg-white py-3 px-4 rounded-lg space-y-2"
                    style={{ boxShadow: "0px 1px 8px 2px #14141414" }}
                  >
                    <div className="text-[14px] leading-6">{v.message}</div>
                    <hr />
                    <div className="flex items-center justify-between text-[#7B7B7B] text-[12px]">
                      <div className="">
                        Devices: {v?.device?.length ? v.device.join(", ") : "all"}
                        {v?.push?.status && (
                          <span className="ml-2">
                            ·{" "}
                            {v.push.status === "sent"
                              ? `Delivered to ${v.push.success}/${v.push.targeted} devices`
                              : v.push.status === "skipped"
                                ? "Not sent (Firebase not configured)"
                                : "Push failed"}
                          </span>
                        )}
                      </div>
                      <div className="">
                        Posted: {new Date(v.createdAt).toLocaleDateString()}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg p-5">
        <div className="flex flex-col gap-4  w-full">
          <div className="font-bold text-[16px]">General notifications</div>
        </div>
      </div>
    </div>
  );
};
